export default __webpack_public_path__ + "static/ritesh_ceo_interview-60d7cf02b945887025874bd5f16e0ab7.mp4";